import axios from '../axios';

export default {
  getManagementCompanies (options) {
    const params = {};

    if (options.pagination) {
      params.pagination = 1;
    }

    if (options.page) {
      params.page = options.page;
    }

    if (options.limit) {
      params.limit = options.limit;
    }

    if (options.filters && Object.keys(options.filters).length) {
      for (const filterName in options.filters) {
        params[`filter[${filterName}]`] = options.filters[filterName];
      }
    }

    if (options.sort) {
      params.sort = options.sort;
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    return new Promise((resolve, reject) => {
      axios.get('/management-company?' + query.join('&'))
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getManagementCompany (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/management-company/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  createManagementCompany (params) {
    return new Promise((resolve, reject) => {
      axios.post('/management-company', params)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  updateManagementCompany (id, data) {
    return new Promise((resolve, reject) => {
      axios.put(`/management-company/${id}`, data)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  deleteManagementCompany (id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/management-company/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
};
